import { render, staticRenderFns } from "./ModalOfferHandlingOptions.vue?vue&type=template&id=55f45c73&scoped=true"
import script from "./ModalOfferHandlingOptions.vue?vue&type=script&lang=js"
export * from "./ModalOfferHandlingOptions.vue?vue&type=script&lang=js"
import style0 from "./ModalOfferHandlingOptions.vue?vue&type=style&index=0&id=55f45c73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f45c73",
  null
  
)

export default component.exports